module.exports = __webpack_public_path__ + "static/media/svg-5.ea73f7aa.svg";